import Header from "@/types/app/header";

export default class AuditLogLogger {
  public static header: Header[] = [
    {
      text: "When",
      align: "start",
      sortable: true,
      value: "when",
      class: "item-table-header item-table-header-entryDateTime",
      width: ""
    },    
    {
      text: "Who",
      align: "start",
      sortable: true,
      value: "who",
      class: "item-table-header item-table-header-name",
      width: ""
    },  
    {
      text: "How",
      align: "start",
      sortable: true,
      value: "accessType",
      class: "item-table-header item-table-header-name",
      width: ""
    },  
    {
      text: "Logs",
      align: "start",
      sortable: true,
      value: "logs",
      class: "item-table-header item-table-header-logs",
      width: ""
    },   
    {
      text: "Total Time",
      align: "start",
      sortable: true,
      value: "total",
      class: "item-table-header item-table-header-name",
      width: ""
    },   
    {
      text: "From Where",
      align: "start",
      sortable: true,
      value: "fromWhere",
      class: "item-table-header item-table-header-name",
      width: ""
    },  
    {
      text: "",
      align: "right",
      value: "actions",
      sortable: false,
      class: null,
      width: ""
    }
  ];
}
